import React from 'react';
import Slider from 'react-slick';

import './blog-post-image-gallery.scss';

class ImageGallery extends React.Component {
  constructor(props) {
    super(props);
  }

  renderImage(image) {
    return (
      <div
        className="blog-post-image-gallery__image"
        key={image.id}
        style={{
          backgroundImage: `url(${
            image.file.url
          }?fm=jpg&q=80&h=600&fl=progressive)`
        }}
      />
    );
  }

  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '200px',
      initialSlide: 1,
      arrows: true,
      responsive: [
        {
          breakpoint: 980,
          settings: {
            centerPadding: '100px'
          }
        },
        {
          breakpoint: 768,
          settings: {
            centerPadding: '50px'
          }
        },
      ]
    };

    return (
      <div className="blog-post-image-gallery">
        <Slider {...settings}>{this.props.images.map(this.renderImage)}</Slider>
      </div>
    );
  }
}

export default ImageGallery;



// WEBPACK FOOTER //
// ./src/components/blog-post-image-gallery.js